import { render, staticRenderFns } from "./AbkCvCertificatesForm.vue?vue&type=template&id=42f8a5a9&scoped=true&"
import script from "./AbkCvCertificatesForm.vue?vue&type=script&lang=js&"
export * from "./AbkCvCertificatesForm.vue?vue&type=script&lang=js&"
import style0 from "./AbkCvCertificatesForm.vue?vue&type=style&index=0&id=42f8a5a9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f8a5a9",
  null
  
)

export default component.exports